import { Table } from "react-bootstrap";
import User from "../../helpers/login/userData";

const ListContainer = (props) => {
  if (props.data) {
    var { list, isKeyVal, title, userData, compClass } = props.data;
  }
  const user = User();
  if (!list && userData) {
    list = [user];
  }
  if (isKeyVal) {
    return (
      <div className={compClass ? compClass : ""}>
        {title && <div className="title">{title}</div>}
        <Table borderless size="sm">
          <tbody>
            {list &&
              list.map((l, idx) =>
                Object.entries(l).map(([key, val], i) => (
                  <tr key={idx + i + 1}>
                    <td className="text-capitalize">{key}</td>
                    <td>{val}</td>
                  </tr>
                ))
              )}
          </tbody>
        </Table>
      </div>
    );
  }
  return <div></div>;
};

export default ListContainer;
